const LS_TOKEN_KEY = 'token';
const LS_USER_KEY = 'user';

// Clear common auth keys too (in case some other code stored under different names)
const EXTRA_AUTH_KEYS = [
  'auth',
  'authToken',
  'accessToken',
  'jwt',
  'jwtToken',
  'refreshToken',
  'userData',
  'persist:root',
];

export function clearAuthStorage() {
  try {
    localStorage.removeItem(LS_TOKEN_KEY);
    localStorage.removeItem(LS_USER_KEY);
    for (const k of EXTRA_AUTH_KEYS) localStorage.removeItem(k);
    sessionStorage.clear();
  } catch {
    // ignore
  }
}

export function clearAuthAndRedirectToLogin() {
  clearAuthStorage();

  try {
    if (window.location.pathname !== '/login') {
      window.location.replace('/login');
    }
  } catch {
    // ignore
  }
}

